module.exports = __webpack_public_path__ + "static/media/vibenwave.2df7cbea.png";